import { createSlice } from "@reduxjs/toolkit";

const tokenFromStorage = localStorage.getItem("accessToken");
const userFromStorage = localStorage.getItem("userProfile");

const initialState = {
  token: tokenFromStorage || null,
  user: userFromStorage ? JSON.parse(userFromStorage) : null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { token, user } = action.payload;
      state.token = token || null;
      state.user = user || null;
      if (token) {
        localStorage.setItem("accessToken", token);
      } else {
        localStorage.removeItem("accessToken");
      }
      if (user) {
        localStorage.setItem("userProfile", JSON.stringify(user));
      } else {
        localStorage.removeItem("userProfile");
      }
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      localStorage.removeItem("accessToken");
      localStorage.removeItem("userProfile");
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
